// 画面上に時計を表示するためのコンポーネント
import React, { useState, useEffect } from 'react';

const CurrentTime: React.FC = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timerId = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => {
      clearInterval(timerId);
    };
  }, []);

  const formatTime = (date: Date) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const adjustedHours = hours % 12 || 12;

    return `${ampm} ${adjustedHours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="clockContainer" style={{ width: 160, paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '0px' }}>
      <h3>{formatTime(time)}</h3>
    </div>
  );
};

export default CurrentTime;
